import { notification } from 'antd';
import Auth from '../utils/authclass'

export const getResponseHandler = (response) => { 
    if (response.data.status === 1) {
        return response.data;
    } else { 
        notification.error({ message: response?.data?.errormessage, placement:'bottomRight' });
        return null;
    }   
}
export const header = ( data = {}, front = 0 ) => {
    let token;
    if(front) 
    token = localStorage.getItem("token")
    else
    token = Auth.getUserToken()
    
    token = token ? token :  null
    return { params: data, headers: {'x-access-token':token } }

}

export const mainHeader = ( front = 0 ) => {
    let token;
    if(front) 
    token = localStorage.getItem("token")
    else
    token = Auth.getUserToken()
    
    token = token ? token :  null
    return { headers: {'x-access-token':token } }

}

//export default getResponseHandler